<template>
    <span></span>
</template>

<script>
  export default {
    props: {
      field: {},
      value: '',
    },
    data() {
        return {
            'min' : 0,
            'defaultQuantity': 1
        };
    },
    created() {
        this.$emit('filled-out', 1);
    }
  };
</script>
